
















import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import BrandForm from '@superUI/Forms/BrandForm'
import RequestButton from '@components/RequestButton'
import TeamSelector from '@superUI/Selectors/TeamSelector'

settings =
  name: "BrandCreate"
  components: {
    Back,
    SuperContainerView,
    BrandForm,
    RequestButton,
    TeamSelector
  }

  resources:
    newBrand:
      resourceName: 'brand'
      slug: 'brands/new'

  vue:
    data: ->
      selectedTeamId: null

    mounted: ->
      @lookupTeamId()

    methods:
      onSave: (item) -> @$router.push({ name: 'BrandShowPage', params: { brandId: item.id } })

      hiBack: ->
        @selectedTeamId = null

      hiSave: ->
        @prime.newBrand.sponsor_id = @selectedTeamId if @selectedTeamId?
        @saveItem('prime.newBrand')
      
      hiTeamSelected: (team) ->
        @selectedTeamId = team.id

      lookupTeamId: ->
        @selectedTeamId = @$route.query.sponsorId if @$route.query.sponsorId?

export default VueOptions.vue settings
